module.exports = __webpack_public_path__ + "static/media/teams-dev-commer.08594d9e.svg";